import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
declare var $;

@Component({
  selector: 'page-liniendiagramm',
  templateUrl: 'liniendiagramm.html',
})
export class LiniendiagrammPage {

  options: Object;
  innerHeight: any;
  innerWidth: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams) {

      this.options = {
        chart: {
            type: 'line',
            marginBottom: 170,
            backgroundColor: '#f7f7f7',
            renderTo: 'chartcontainer',
            margin: [0, 0, 0, 0],
            spacingTop: 0,
            spacingBottom: 0,
            spacingLeft: 0,
            spacingRight: 0,
            colors: "['#4F4F4F', '#D4AF37']",
        },
        title: {
            text: 'Solar Employment Growth by Sector, 2010-2016'
        },
        subtitle: {
            text: 'Description about ChartData'
        },
        yAxis: {
            title: {
                text: 'Number of Employees'
            }
        },
        legend: {
            layout: 'vertical',
            align: 'bottom',
            verticalAlign: 'bottom',
            floating: false,
            x: 0,
            y: 0,
        },
        plotOptions: {
            series: {
                pointStart: 2010
            }
        },
        series: [{
            name: 'Installation',
            data: [43934, 52503, 57177, 69658, 97031, 119931, 137133, 154175]
        }, {
            name: 'Manufacturing',
            data: [24916, 24064, 29742, 29851, 32490, 30282, 38121, 40434]
        }, {
            name: 'Sales & Distribution',
            data: [11744, 17722, 16005, 19771, 20185, 24377, 32147, 39387]
        }, {
            name: 'Project Development',
            data: [null, null, 7988, 12169, 15112, 22452, 34400, 34227]
        }, {
            name: 'Other',
            data: [12908, 5948, 8105, 11248, 8989, 11816, 18274, 18111]
        }]
      };
  }
}



// WEBPACK FOOTER //
// ./src/pages/liniendiagramm/liniendiagramm.ts